import lodashSet from 'lodash/set';

export const updateStateProps = (mutatationKey) => {
  return ({commit}, tobeUpdatedProps) => {
    commit(mutatationKey, tobeUpdatedProps);
  };
};

export const mutateStateProps = (state, tobeUpdatedProps) => {
  Object.entries(tobeUpdatedProps).forEach(([key, value]) => {
    // support array path as key for lodash set
    if (key.slice(0, 1) === '[' && key.slice(-1) === ']') {
      lodashSet(state, JSON.parse(key.replaceAll('\'', '"')), value);
    } else {
      lodashSet(state, key, value);
    }
  });
};
